import React, { useState } from "react";
import {
  LessonsModal,
  ExamsModal,
  ClassroomsModal,
} from "../../../components/modal";
import ThisMonth from "./ThisMonth";
import ThisWeek from "./ThisWeek";
import Today from "./Today";

export default function LeaderBoardHeader({ onChangeTitle }) {
  const [selectedView, setSelectedView] = useState("today");
  const [filter, setFilter] = useState("Lessons");
  const [modalType, setModalType] = useState(null); // State to manage the modal type

  function handleChangePeriodToday(period) {
    setSelectedView(period);
    onChangeTitle("Today Participant");
  }
  function handleChangePeriodThisWeek(period) {
    setSelectedView(period);
    onChangeTitle("This Week Participant");
  }
  function handleChangePeriodThisMonth(period) {
    setSelectedView(period);
    onChangeTitle("This Month Participant");
  }

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
    setModalType(e.target.value); // Set the modal type based on filter value
  };

  const closeModal = () => {
    setModalType(null); // Close the modal
  };

  function renderPages() {
    switch (selectedView) {
      case "today":
        return <Today />;
      case "week":
        return <ThisWeek />;
      case "month":
        return <ThisMonth />;
      default:
        <Today />;
    }
  }
  return (
    <>
      <div className="flex items-center justify-between">
        <div className="space-x-4 mb-4">
          <button
            className={`font-satoshi font-medium text-16 ${
              selectedView === "today" ? "text-[#400167] " : "text-[#080014]"
            }`}
            onClick={() => handleChangePeriodToday("today")}
          >
            Today
          </button>
          <button
            className={`font-satoshi font-medium text-16 ${
              selectedView === "week" ? "text-[#400167] " : "text-[#080014]"
            }`}
            onClick={() => handleChangePeriodThisWeek("week")}
          >
            This Week
          </button>
          <button
            className={`font-satoshi font-medium text-16  ${
              selectedView === "month" ? "text-[#400167]" : "text-[#080014]"
            }`}
            onClick={() => handleChangePeriodThisMonth("month")}
          >
            This Month
          </button>
        </div>
        <div>
          {" "}
          <ShowingCategoryOfStudent
            filter={filter}
            changeFilter={handleFilterChange}
          />
        </div>
        {/* Render modals conditionally */}
        <LessonsModal isOpen={modalType === "Lessons"} onClose={closeModal} />
        <ExamsModal isOpen={modalType === "Exams"} onClose={closeModal} />
        <ClassroomsModal
          isOpen={modalType === "Classrooms"}
          onClose={closeModal}
        />
      </div>
      <div>{renderPages()}</div>
    </>
  );
}

function ShowingCategoryOfStudent({ filter, changeFilter }) {
  return (
    <div className="flex items-center gap-4">
      <span className="font-semibold text-[#000000] text-[20px]">Showing:</span>
      <div className="relative">
        <select
          value={filter}
          onChange={changeFilter}
          className="text-[#400167] border bg-[#F4F4F4] rounded-lg py-3 px-4 w-[248px] font-bold"
        >
          <option value="Lessons">Lessons</option>
          <option value="Exams">Exams</option>
          <option value="Classrooms">Classrooms</option>
        </select>
      </div>
    </div>
  );
}

